<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-button class="btn-round"
                          @click="updateData"
                          variant="success">{{$t('saveTitle')}}</b-button>
            </template>
        </navbar>

        <b-row>
            <b-col cols="12" md="6">
                <b-row>
                    <b-col cols="12" md="6">
                        <template v-if="filter.value ==='slider1'">
                            <b-input v-model="title.slider1"></b-input>
                        </template>
                        <template v-else-if="filter.value ==='slider2'">
                            <b-input v-model="title.slider2"></b-input>
                        </template>
                        <template v-else-if="filter.value ==='slider3'">
                            <b-input v-model="title.slider3"></b-input>
                        </template>
                        <template v-else-if="filter.value ==='slider4'">
                            <b-input v-model="title.slider4"></b-input>
                        </template>
                    </b-col>
                    <b-col cols="12" md="6">
                        <template v-if="filter.value === 'slider2'">
                            <b-form-checkbox v-model="title.slider2Hide">hide?</b-form-checkbox>
                        </template>
                        <template v-if="filter.value === 'slider3'">
                            <b-form-checkbox v-model="title.slider3Hide">hide?</b-form-checkbox>
                        </template>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-select
                        @change="getSettingTitle"
                        v-model="filter.value" :options="filter.items"></b-form-select>
            </b-col>
        </b-row>

        <template v-if="items.length > 0">
            <draggable :move="onMoveItem" v-model="items" group="items" @start="drag=true"
                       @end="drag=false">
                <b-card v-for="(item,index) in items" :key="index">
                    <b-media>
                        <template #aside>
                            <b-img :src="item.image" width="64" alt="placeholder"></b-img>
                        </template>

                        <h5 class="mt-0">{{item.title}}</h5>
                        <p>
                            <template v-if="filter.value === 'slider1'">
                                <b-form-checkbox
                                        :id="'ch'+index"
                                        :name="'ch'+index"
                                        :value="item.id"
                                        v-model="form.slider1"
                                        @change="onCheckItem(item)"
                                >
                                    <span>select</span>
                                </b-form-checkbox>
                            </template>
                            <template v-else-if="filter.value === 'slider4'">
                                <b-form-checkbox
                                        :id="'ch'+index"
                                        :name="'ch'+index"
                                        :value="item.id"
                                        v-model="form.slider4"
                                        @change="onCheckItem(item)"
                                >
                                    <span>select</span>
                                </b-form-checkbox>
                            </template>

                        </p>

                    </b-media>
                </b-card>
            </draggable>

        </template>

    </div>
</template>

<script>
    import Navbar from "../../Partials/Navbar";
    import draggable from 'vuedraggable'
    import Http from '../../../Services/HttpService/HttpService'
    import Notificaion from '../../../Services/Notification/Nottification'

    export default {
        name: "Index",
        components: {
            Navbar,
            draggable
        },
        data() {
            return {
                items: [],
                filter: {
                    items: [
                        {
                            text: 'slider 1',
                            value: 'slider1'
                        },
                        {
                            text: 'slider 2',
                            value: 'slider2'
                        },
                        {
                            text: 'slider 3',
                            value: 'slider3'
                        }, {
                            text: 'slider 4',
                            value: 'slider4'
                        },
                    ],
                    value: 'slider1'
                },
                form: {
                    slider1: [],
                    slider2: [],
                    slider3: [],
                    slider4: [],
                },
                title: {
                    slider1: null,
                    slider2Hide: false,
                    slider2: null,
                    slider3Hide: false,
                    slider3: null,
                    slider4: null,
                },
            }
        },
        methods: {
            onMoveItem(e) {
                this.items.filter(item => {
                    if (item.id === e.draggedContext.element.id) {
                        item.changed = true;
                    } else {
                        item.changed = false;
                    }
                })
            },
            onCheckItem(e) {
                this.items.filter(item => {
                    if (item.id === e.id && e.selected === false) {
                        item.selected = true;
                    } else if (item.id === e.id && e.selected === true) {
                        item.selected = false;
                    }
                })
            },
            getSettingTitle() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'setting/home/index')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.title.slider1 = response.data.data.slider_one_title;
                            this.title.slider2 = response.data.data.slider_two_title;
                            this.title.slider3 = response.data.data.slider_three_title;
                            this.title.slider4 = response.data.data.slider_four_title;
                            this.title.slider2Hide = response.data.data.slider_two_hide;
                            this.title.slider3Hide = response.data.data.slider_three_hide;
                        }

                        this.getItemsByType();
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getItemsByType() {
                this.$Progress.start();
                let type = this.filter.value;
                Http.get(Http.apiurlV2() + 'setting/home/show/' + type)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.items = response.data.data;

                            if (type === 'slider1') {
                                this.items.filter(item => {
                                    if (item.selected) {
                                        this.form.slider1.push(item.id);
                                    }
                                })
                            }

                            if (type === 'slider4') {
                                this.items.filter(item => {
                                    if (item.selected) {
                                        this.form.slider4.push(item.id);
                                    }
                                })
                            }

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateData() {
                let formdata = {};
                if (this.filter.value === 'slider1' || this.filter.value === 'slider4') {
                    this.form.slider1 = [];
                    this.form.slider4 = [];
                    this.items.filter(item => {
                        if ((item.changed && item.selected) || (!item.changed && item.selected)) {
                            if (this.filter.value === 'slider1') {
                                this.form.slider1.push(item.id);
                            } else {
                                this.form.slider4.push(item.id);
                            }

                        } else {
                            this.items.slice(this.items.indexOf(item), 1);
                        }
                    });

                    formdata = {
                        type: this.filter.value,
                        title: (this.filter.value === 'slider1' ? this.title.slider1 : this.title.slider4),
                        value: (this.filter.value === 'slider1' ? this.form.slider1 : this.form.slider4),
                    }
                } else {
                    formdata = {
                        type: this.filter.value,
                        title: (this.filter.value === 'slider2' ? this.title.slider2 : this.title.slider3),
                        value: (this.filter.value === 'slider2' ? this.title.slider2Hide : this.title.slider3Hide),
                    }
                }

                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'setting/home/update', formdata)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            if (this.filter.value === 'slider1') {
                                this.form.slider1 = [];
                            }
                            if (this.filter.value === 'slider4') {
                                this.form.slider4 = [];
                            }
                            this.$Progress.finish();
                            this.getSettingTitle();
                            this.getItemsByType(this.filter.value);

                            Notificaion.success(response.data.message)
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            },
        },
        created() {
            this.getSettingTitle();
            this.getItemsByType();
        }
    }
</script>

<style scoped>

</style>